// src/components/custom-select/index.tsx
import React from "react";
import { MenuItem, SelectChangeEvent } from "@mui/material";
import { Label, StyledSelect, Wrapper } from "./styles";
import LocationOnIcon from "@mui/icons-material/LocationOn"; // Ícone padrão

interface CustomSelectProps {
  label: string;
  value: unknown;
  onChange: (event: SelectChangeEvent<unknown>) => void;
  options: string[];
  placeholder?: string;
  IconComponent?: React.ElementType;
}

export const CustomSelect: React.FC<CustomSelectProps> = ({
  label,
  value,
  onChange,
  options,
  placeholder,
  IconComponent = LocationOnIcon,
}) => {
  return (
    <Wrapper>
      <Label>{label}</Label>
      <StyledSelect
        value={value}
        onChange={onChange}
        displayEmpty
        IconComponent={IconComponent}
        renderValue={(selected: unknown) => {
          if (!selected || selected === "") {
            return <span style={{ color: "#9ca3af" }}>{placeholder}</span>;
          }
          return String(selected);
        }}
      >
        {options.map((option) => (
          <MenuItem key={option} value={option}>
            {option}
          </MenuItem>
        ))}
      </StyledSelect>
    </Wrapper>
  );
};